export default __webpack_public_path__ + "static/media/calendar.d6058a3d.svg";